// extracted by mini-css-extract-plugin
var _1 = "Divider_divider__9b919";
var _2 = "Divider_lineContainer__9abe8";
var _3 = "Divider_number__11253";
var _4 = "Divider_numberExplanation__39671";
var _5 = "Divider_numberExplanationWrapper__a43e2";
var _6 = "Divider_root__5c0db";
var _7 = "Divider_v2__4341f";
export { _1 as "divider", _2 as "lineContainer", _3 as "number", _4 as "numberExplanation", _5 as "numberExplanationWrapper", _6 as "root", _7 as "v2" }
